import { useEffect } from 'react';

/**
 * SEOHead — sets document title, canonical, and meta tags per route.
 * Uses vanilla DOM (no extra deps). Works with Google's JS rendering.
 *
 * IMPORTANT: index.html does NOT have a hardcoded canonical anymore.
 * This component creates/updates it dynamically so each page gets the correct one.
 */
export default function SEOHead({ title, description, canonical, ogImage }) {
  useEffect(() => {
    // ── Title ──────────────────────────────────────────────────────────────
    if (title) {
      document.title = title;
    }

    // ── Meta description ───────────────────────────────────────────────────
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc && description) {
      metaDesc.setAttribute('content', description);
    }

    // ── Canonical — create if missing, always update ───────────────────────
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement('link');
        link.setAttribute('rel', 'canonical');
        document.head.appendChild(link);
      }
      link.setAttribute('href', canonical);
    }

    // ── OG tags ────────────────────────────────────────────────────────────
    const ogData = {
      'og:title':       title,
      'og:description': description,
      'og:url':         canonical,
      'og:image':       ogImage || 'https://www.casacartarum.ro/og-image.jpg',
    };
    Object.entries(ogData).forEach(([property, content]) => {
      if (!content) return;
      const meta = document.querySelector(`meta[property="${property}"]`);
      if (meta) meta.setAttribute('content', content);
    });

    // ── Twitter tags ───────────────────────────────────────────────────────
    const twitterData = {
      'twitter:title':       title,
      'twitter:description': description,
      'twitter:image':       ogImage || 'https://www.casacartarum.ro/og-image.jpg',
    };
    Object.entries(twitterData).forEach(([name, content]) => {
      if (!content) return;
      const meta = document.querySelector(`meta[name="${name}"]`);
      if (meta) meta.setAttribute('content', content);
    });
  }, [title, description, canonical, ogImage]);

  return null;
}
